import React from 'react';
import PropTypes from 'prop-types';
import HeaderSection from '../components/HeaderSection';
import InfoSection from '../components/InfoSection';
import ButtonSection from '../components/ButtonSection';
import { ACTIVE } from '../constants';

const NotActive = ({ label, labelBtn, onToggle }) => (
  <div>
    <HeaderSection labelTitle={label.title} labelSubtitle={label.subTitle} />

    <div className="row padding-top-1">
      <div className="col-sm-5 col-xs-12">
        <InfoSection
          className="row"
          labelTitle={label.controlPin.title}
          labelDescription={label.controlPin.description}
        />
        <InfoSection
          className="row"
          labelTitle={label.paymentProtection.title}
          labelDescription={label.paymentProtection.description}
        />
      </div>
    </div>
    <div className="row">
      <ButtonSection
        desactive
        className="pull-right"
        labelCancel={labelBtn.btnActive}
        onToggle={() => onToggle(ACTIVE)}
      />
    </div>
  </div>
);

NotActive.propTypes = {
  label: PropTypes.object,
  labelBtn: PropTypes.object,
  onToggle: PropTypes.func,
};
export default NotActive;
